// External Imports
import { createSelector } from 'reselect';

// Internal Imports
import { getContentType } from './getMatch.mjs';
import { createGetContentItemBySlug } from './createGetContentItem.mjs';

// Local Functions
const getActiveContentItemBySlug = createSelector([getContentType], (contentType) =>
  createGetContentItemBySlug(contentType),
);

const getActiveContentItem = createSelector(
  [
    getActiveContentItemBySlug,
    // This sucks for memoization, but getItem for now is made in a way that doesn't get better than that
    (state) => state,
  ],
  (getItem, state) => getItem(state),
);

// Module Exports
export { getActiveContentItem };
